"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiPagination = getMuiPagination;
function getMuiPagination() {
  return {
    styleOverrides: {
      root: function (_ref) {
        var theme = _ref.theme;
        return {
          '.MuiPaginationItem-root': {
            '&:active, &:hover': {
              backgroundColor: theme.palette.gray[100],
              color: theme.palette.gray[600]
            },
            color: theme.palette.gray[600]
          },
          borderRadius: 32,
          boxShadow: theme.shadows[1],
          color: theme.palette.gray[700],
          padding: theme.spacing[1.5]
        };
      }
    }
  };
}